module.exports = __webpack_public_path__ + "static/media/Lambda.bd415be4.svg";